import cn from 'classnames';
import React from 'react';
import { useQuestionTitleContext, useRegisterTitleRef } from '../../entrypoints/root/QuestionTitleContext';
import Markdown from '../Markdown';
import styles from './QuestionTitle.module.css';

interface QuestionTitleProps {
  className?: string;
  children?: string;
  required?: boolean;
  questionId: string;
  alignment: 'left' | 'center';
}

export const QuestionTitle = ({ className, children = '', required, questionId, alignment }: QuestionTitleProps) => {
  const { registerTitleRef } = useRegisterTitleRef(questionId);
  const { isGroupPage } = useQuestionTitleContext();

  const text = children.trim();
  const endsWithCode = children.endsWith('```');
  const showRequiredSymbol = required && isGroupPage;

  if (!text) return null;

  return (
    <h1
      ref={registerTitleRef}
      className={cn(className, styles.title, { [c(styles.alignCenter)]: alignment === 'center' })}
    >
      <Markdown>
        {`${text}${showRequiredSymbol && !endsWithCode ? `<span class=${styles.requiredSymbol}>*</span>` : ''}`}
      </Markdown>

      {showRequiredSymbol && endsWithCode && <span className={styles.requiredSymbol}>*</span>}
    </h1>
  );
};
